import React from 'react';
import {
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Icon,
  FormControlLabel,
  Checkbox,
  CircularProgress
} from '@material-ui/core';
import { useStyles } from './styles';
import { extractApiErrorMessage, notifications } from '../../utils';
import { AnimalTypeSelect, LocationStableSelect } from '../../elements';
import { useTranslation } from 'react-i18next';
import { TasksService } from '../../hooks';
import { CreateTaskListCommand } from '../../models/tasks';

interface CreateTaskListModalProps {
  opened: boolean;
  onModalAction: (result: boolean) => void;
}

const CreateTaskListModal: React.FC<any> = ({ opened, onModalAction }: CreateTaskListModalProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const tasksService = new TasksService();

  const [animalType, setAnimalType] = React.useState(0);
  const [stableType, setStableType] = React.useState(0);
  const [sickOnly, setSickOnly] = React.useState(false);

  const [isBusy, setIsBusy] = React.useState(false);

  React.useEffect(() => {
    if (opened) {
      clearFields();
    }
  }, [opened]);

  const closeDialog = (text: string | null) => {
    if (text == null) {
      clearFields();
      onModalAction(false);
      return;
    }

    if (!validateForm()) {
      return;
    }

    setIsBusy(true);

    tasksService
      .createTaskList(buildCreateTaskListCommand())
      .then(() => {
        notifications.success(t('f-tasks-lists-add-ok'));
        onModalAction(true);
        clearFields();
      })
      .catch((e) => {
        notifications.error(extractApiErrorMessage(e, { fallback: t('f-com-api-error') }));
      })
      .finally(() => {
        setIsBusy(false);
      });
  };

  const buildCreateTaskListCommand = (): CreateTaskListCommand => {
    return {
      animalType,
      stableType,
      sickOnly
    } as CreateTaskListCommand;
  };

  const validateForm = (): boolean => {
    // if (animalType === AnimalType.Unknown) {
    //   notifications.warning(t('f-val-anim-type'));
    //   return false;
    // }

    // if (stableType === LocationStable.Unknown) {
    //   notifications.warning(t('f-val-stable-type'));
    //   return false;
    // }

    return true;
  };

  const clearFields = () => {
    setSickOnly(false);
    setAnimalType(0);
    setStableType(0);
  };

  return (
    <Dialog
      id="createTaskListDialog"
      open={opened}
      onClose={() => closeDialog(null)}
      className={classes.dialog}
      maxWidth="sm"
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="createTaskListDialogTitle" className={classes.dialogHeaderFooter}>
        {t('f-tasks-lists-add-btn')}
      </DialogTitle>

      <DialogContent>
        <Grid container direction="column" spacing={2} className={classes.updateForm}>
          <Grid item container direction="column" spacing={1}>
            <Grid item>
              <AnimalTypeSelect
                value={animalType}
                cssClass={classes.formControl}
                allowAny
                onAnimalTypeChange={(type) => {
                  setAnimalType(type);
                }}
              />
            </Grid>

            <Grid item>
              <LocationStableSelect
                value={stableType}
                cssClass={classes.formControl}
                // fullWidth
                allowAny
                onLocationStableChange={(value) => setStableType(value)}
              />
            </Grid>

            <Grid item>
              <FormControlLabel
                className={classes.formControl}
                control={
                  <Checkbox
                    checked={sickOnly}
                    onChange={(e) => {
                      setSickOnly(e.target.checked);
                    }}
                    color="primary"
                  />
                }
                label={t('f-tasks-lists-sick-only')}
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions className={classes.dialogHeaderFooter}>
        {isBusy && <CircularProgress />}

        <Button onClick={() => closeDialog(null)} variant="outlined" startIcon={<Icon>{'close'}</Icon>} color="primary">
          {t('f-com-cancel')}
        </Button>

        <Button
          onClick={() => closeDialog('ok')}
          id="addRuleBtn"
          disabled={isBusy}
          startIcon={<Icon>{'add_circle_outline'}</Icon>}
          variant="contained"
          color="primary"
        >
          {t('f-com-create')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateTaskListModal;
